import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-width: 388px;
  height: 100%;
  font-family: "Avenir Next";
  padding: 24px;
  align-items: flex-start;
  border-radius: 8px;
  background: rgba(52, 199, 89, 0.20);
  color: #000;
  .text-mobile {
    display: none;
  }
  &.mobile {
    display: none;
  }
  div:first-child {
    flex-basis: 80%
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 100%;
    padding: 10px;
    maring-block: 20px;
    border-radius: 50px;
    color: #302628;
    border: 1.5px solid #302628;
    background: #F7F7F7;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    @media (max-width: 698px) {
      background: #302628;
      color: #FFF;
    }
  }
  h1 {
    font-size: 20px;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  @media (max-width: 698px) {
    height: unset;
    min-width: 100%;
    border: 1px solid #34C759;
    background: rgba(52, 199, 89, 0.12);
    color: #625F5F;
    &.desktop {
      display: none;
    }
    &.mobile {
      display: flex;
    }
    h1 {
      font-size: 18px;
    }
    .text-desktop {
      display: none;
    }
    .text-mobile {
      display: inline;
      i {
        margin-inline: 6px;
        font-size: 16px;
      }
    }
  }
  &.self {
    margin-inline: auto;
    margin-bottom: 16px;
    span {
      line-height: 28px;
      :first-child {
        font-weight: 600;
      }
    }
    & > button {
      background: #302628;
      color: #FFF;
    }
    @media (max-width: 698px) {
      span {
        font-weight: 600;
      }
    }
  }
  &.mt {
    height: fit-content;
    margin-top: 16px;
    background: #FFF;
    @media (max-width: 698px) {
      background: rgba(52, 199, 89, 0.20);
    }
    & > button {
      margin-top: 20px;
    }
  }
  &.menu { 
    padding: 12px 12px;
    min-width: 100%;
    border: 1px solid #34C759;
    div:first-child {
      flex-basis: 100%;
      white-space: normal;
      word-break: break-word;
      text-align: start;
      font-size: 14px;
      text-transform: none;
      line-height: 28px;
      p {
        font-size: 12px;
        font-weight: normal;
      }
      h1 {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 0;
        line-height: 1.5;
      }
    }
    & > button {
      background: #302628;
      color: #FFF;
      font-weight: 500;
    }
    .text-desktop {
      display: none;
    }
    .text-mobile {
      display: flex;
      i {
        display: none;
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FeedbackCTA/styledComponents.tsx